import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/sections/Footer';
import { TextLink } from '../components/sections/TextLink';
import { responsiveImg } from '../lib/imageUrl';
import { useSlotImage } from '../lib/useSlotImage';
import { UNIVERSES } from '../lib/universes';
import { WeddingsContent } from './universes/WeddingsContent';
import { ReceptionsContent } from './universes/ReceptionsContent';
import { HeritageContent } from './universes/HeritageContent';

const UniverseContent = ({ u }) => {
  const image = useSlotImage(u.slot, u.fallback);
  return (
    <main data-testid={`universe-page-${u.slug}`}>
      <section className="container-custom pt-20 md:pt-32 pb-20 md:pb-28">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}>
          <span className="block text-[11px] uppercase tracking-[0.3em] text-[#6B6B6B] mb-8">Univers {u.n}</span>
          <h1 className="font-serif font-light text-[#111111] text-5xl sm:text-6xl lg:text-8xl leading-[1.02] max-w-5xl" data-testid="universe-title">
            {u.title}
          </h1>
          <p className="mt-10 text-sm md:text-base leading-[1.9] font-light text-[#333333] max-w-md">{u.desc}</p>
        </motion.div>
      </section>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.4, delay: 0.3 }} className="w-full aspect-[4/5] sm:aspect-[16/9] lg:aspect-[21/9] overflow-hidden bg-[#F5F5F5]">
        <img {...responsiveImg(image, '100vw', { eager: true })} alt={`${u.title} — image d'illustration`} className="w-full h-full object-cover" data-testid="universe-hero-image" />
      </motion.div>
      <section className="container-custom py-24 md:py-32 flex flex-col sm:flex-row gap-10 sm:gap-16">
        <TextLink to="/devis" testId="universe-cta-devis">Demander un devis</TextLink>
        <TextLink to="/#univers" testId="universe-back">Les trois univers</TextLink>
      </section>
    </main>
  );
};

export default function UniversePage() {
  const { slug } = useParams();
  const u = UNIVERSES.find((x) => x.slug === slug);
  if (!u) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#111111]">
      <Navbar />
      {slug === 'weddings' ? <WeddingsContent /> : slug === 'receptions-corporate' ? <ReceptionsContent /> : slug === 'heritage' ? <HeritageContent /> : <UniverseContent u={u} />}
      <Footer />
    </div>
  );
}
